import { ADD_FIELD, ADD_USERS, ADD_STATES, ADD_COUNTRIES, ADD_TAB, ADD_FORM_TITLE, UPDATE_FIELDS, ADD_ALL_GROUP_USERS } from './constants';
import { IAddField, IAddUsers, IAddStates, IAddCountries, IAddTab, IAddFormTitle, IUpdateFields, IGetAllGroupUsers } from './interfaces';
import { ITabField, IStateObject, ICountryObject, IGroupUsers } from '@logicmanager/common';

export function addField(field: ITabField): IAddField {
    return {
        type: ADD_FIELD,
        field,
    };
}

export function addUsers(users: any): IAddUsers {
    return {
        type: ADD_USERS,
        users,
    };
}

export function updateFields(fields: {[fieldId: string]: ITabField}): IUpdateFields {
    return {
      type: UPDATE_FIELDS,
      fields
    };
  }

export function addStates(states: IStateObject[]): IAddStates {
    return {
        type: ADD_STATES,
        states,
    };
}

export function addCountries(countries: ICountryObject[]): IAddCountries {
    return {
        type: ADD_COUNTRIES,
        countries,
    };
}

export function addTab(tab: ITabField): IAddTab {
    return {
        type: ADD_TAB,
        tab
    };
}

export function addFormTitle(title: string): IAddFormTitle {
    return {
        type: ADD_FORM_TITLE,
        title
    };
}

export function addGroupUsers(groupUsers: IGroupUsers): IGetAllGroupUsers {
    return {
        type: ADD_ALL_GROUP_USERS,
        groupUsers
    };
}
